import { IonPage } from '@ionic/react';
import styled from 'styled-components';

import { OnboardingPageBgVariantType } from './types';

export const PageStyles = styled(IonPage)<{
  background: OnboardingPageBgVariantType;
}>`
  body.dark & {
    ${({ background }) => {
      switch (background) {
        case 'dark-gradient':
          return `
            --onboarding-page-bg: linear-gradient(
              360deg,
              #2b0e21 0%,
              #14111e 49.18%,
              #1e0f34 100%
            );
            --onboarding-page-container-overflow-gradient: linear-gradient(
              180deg,
              rgba(20, 17, 30, 0) 31.52%,
              rgba(20, 17, 30, 0.86) 64.2%,
              rgb(20, 17, 30) 91.3%
            );
          `;
        case 'dark-violet':
          return `
            --onboarding-page-bg: linear-gradient(0deg, #734B6D 0%, #42275A 100%);
            --onboarding-page-container-overflow-gradient: linear-gradient(180deg, rgba(67, 40, 91, 0.00) 0%, rgba(67, 40, 91, 0.00) 40.11%, rgba(67, 40, 91, 0.90) 72.43%, #43285B 84.99%);
          `;
        case 'domination':
          return `
        --onboarding-page-bg: #000000;
        --onboarding-page-container-overflow-gradient: linear-gradient( 180deg, rgba(0, 0, 0, 0) 31.52%, rgba(33, 0, 0, 0.86) 64.2%, rgb(0, 0, 0) 91.3% );
      `;
        case 'dark-forest':
          return `
            --onboarding-page-bg: linear-gradient(180deg, #08140A 0%, #0A1428 50%, #0D1A0F 100%);
            --onboarding-page-container-overflow-gradient: linear-gradient(180deg, rgba(8, 20, 10, 0) 30%, rgba(10, 20, 40, 0.7) 65%, #0D1A0F 90%);
          `;
        case 'purple-gradient':
          return `
            --onboarding-page-bg: linear-gradient(180deg, #000000 0%, #000000 20%, #27013C 100%);
            --onboarding-page-container-overflow-gradient: linear-gradient(180deg, rgba(0, 0, 0, 0) 30%, rgba(39, 1, 60, 0.7) 65%, #27013C 90%);
          `;
        case 'dark-solid':
          return `
            --onboarding-page-bg: #14111E;
            --onboarding-page-container-overflow-gradient: linear-gradient(180deg, rgba(20, 17, 30, 0) 30%, rgba(20, 17, 30, 0.7) 65%, #14111E 90%);
          `;
        default:
          return `
          --onboarding-page-bg: linear-gradient(
            360deg,
            #2b0e21 0%,
            #14111e 49.18%,
            #1e0f34 100%
          );
          --onboarding-page-container-overflow-gradient: linear-gradient(
            180deg,
            rgba(20, 17, 30, 0) 31.52%,
            rgba(20, 17, 30, 0.86) 64.2%,
            rgb(20, 17, 30) 91.3%
          );
        `;
      }
    }}
  }

  --onboarding-page-bg: #e6dee6;
  --onboarding-page-container-overflow-gradient: linear-gradient(
    180deg,
    rgba(230, 222, 230, 0) 31.52%,
    rgba(230, 222, 230, 0.857969) 64.2%,
    #e6dee6 91.3%
  );

  background: var(--onboarding-page-bg);

  ion-content {
    --background: unset;
  }
`;

export const PageContainerStyles = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100%;
  max-width: 500px;
  width: 100%;
  margin: 0 auto;
  position: relative;
`;

export const PageBgImageStyles = styled.div<{
  bgImageMask: boolean;
}>`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: -1;
  overflow: hidden;

  ${({ bgImageMask }) =>
    bgImageMask &&
    `
      &::after {
        content: '';
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: var(--onboarding-page-container-overflow-gradient);
      }
    `}

  & > img {
    height: 100%;
    object-fit: cover;
    object-position: 50% 0%;
    width: 100%;
  }

  video {
    height: 100%;
    object-fit: cover;
    object-position: center;
    width: 100%;
  }
`;
